
export const VERSION = {
    CURRENT_VERSION: 'V3.13.2',
    CURRENT_SUB_VERSION: '1'
};
